import lrCodeEditorPanel from './_src/lrCodeEditorPanel.vue'

lrCodeEditorPanel.install = function(Vue) {
  Vue.component(lrCodeEditorPanel.name, lrCodeEditorPanel)
}

export default lrCodeEditorPanel